import type { LinkShareTemplateData } from '~/components/communications/LinkShare';
import { GENERIC_TEMPLATES_ROUTES } from '~/components/GenericTemplates/utils/routes';
import type { UseDataFetcherOptions } from '~/components/useDataFetcher';
import useDataFetcher from '~/components/useDataFetcher';

interface DocumentRequestShareTemplateParams {
  // The claim's organization, not the logged-in user's: a super-organization user shares another
  // organization's link.
  organizationId: number;
  claimId: number;
  documentRequestId: number;
  contactId: number;
}

// The organization's share message for a link already generated on the claim, filled on the server for the
// contact it is sent to, as the video call fetches its invitation. The server never creates a link here.
const useDocumentRequestShareTemplate = (
  { organizationId, claimId, documentRequestId, contactId }: DocumentRequestShareTemplateParams,
  options?: UseDataFetcherOptions
) =>
  useDataFetcher<LinkShareTemplateData>(
    GENERIC_TEMPLATES_ROUTES.GENERATE_DOCUMENT_REQUEST_SHARE({ organizationId, claimId, documentRequestId, contactId }),
    null,
    options
  );

export default useDocumentRequestShareTemplate;
